import React, { useEffect, useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';

// asset
import placeholders from "./placeholder-large-h.png";

export default function Image({
    fill = false,
    className = "",
    alt = "",
    style,
    src,
    onLoadingComplete,
    sizes,
    placeholder = placeholders,
    ...args
}) {
    const [currentSrc, setCurrentSrc] = useState(src);

    useEffect(() => {
        setCurrentSrc(src);
    }, [src])

    const onImageError = () => {
        setCurrentSrc(placeholder);
    };

    return (
        <div className="relative w-100 h-100">
            <LazyLoadImage
                {...args}
                src={currentSrc}
                alt={alt}
                onError={onImageError}
                onLoad={onLoadingComplete}
                sizes={sizes}
                placeholderSrc={placeholder}
                className="w-100 h-100 object-fit-cover"
            />

        </div>
    );
}
